import React, { useEffect, useState } from "react";
import { CalendarX2, X } from "lucide-react";

import "../../Formation/ResponsableFormation/RessourcesStyles/EventManagement.css";
import { formatCalendarDate } from "../utils/calendarHelpers";

const initialForm = {
    motif: "",
    comment: "",
};

export default function EventWithdrawalRequestModal({
    open,
    event,
    loading,
    title = "Demander un désistement",
    motifLabel = "Motif *",
    motifPlaceholder = "Ex: indisponibilité, contrainte opérationnelle...",
    submitLabel = "Confirmer",
    loadingLabel = "Envoi...",
    errorMessage = "Le motif est obligatoire.",
    onClose,
    onSubmit,
}) {
    const [form, setForm] = useState(initialForm);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!open) {
            setForm(initialForm);
            setError("");
        }
    }, [open]);

    if (!open || !event) return null;

    const handleSubmit = (submitEvent) => {
        submitEvent.preventDefault();

        if (!form.motif.trim()) {
            setError(errorMessage);
            return;
        }

        setError("");
        onSubmit({
            motif: form.motif.trim(),
            comment: form.comment.trim(),
        });
    };

    return (
        <div className="ev-modal-overlay" onClick={onClose}>
            <div className="ev-modal ev-modal--small" onClick={(eventTarget) => eventTarget.stopPropagation()}>
                <div className="ev-modal-header">
                    <h3>
                        <CalendarX2 size={16} />
                        {title}
                    </h3>
                    <button type="button" className="ev-x" onClick={onClose} aria-label="Fermer">
                        <X size={18} />
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="ev-modal-body">
                        <div className="ev-grid">
                            <div className="ev-field ev-span-2">
                                <label>Événement</label>
                                <input value={event.titre || ""} disabled className="ev-input" />
                            </div>

                            <div className="ev-field">
                                <label>Date début</label>
                                <input value={formatCalendarDate(event.dateDebut, true)} disabled className="ev-input" />
                            </div>

                            <div className="ev-field">
                                <label>Date de fin</label>
                                <input value={formatCalendarDate(event.dateFin, true)} disabled className="ev-input" />
                            </div>

                            <div className="ev-field ev-span-2">
                                <label>{motifLabel}</label>
                                <input
                                    type="text"
                                    className="ev-input"
                                    value={form.motif}
                                    onChange={(eventTarget) => {
                                        setForm((current) => ({ ...current, motif: eventTarget.target.value }));
                                        if (error) setError("");
                                    }}
                                    placeholder={motifPlaceholder}
                                />
                                {error ? (
                                    <div style={{ color: "#c2410c", fontSize: 12, marginTop: 6 }}>{error}</div>
                                ) : null}
                            </div>

                            <div className="ev-field ev-span-2">
                                <label>Commentaire</label>
                                <textarea
                                    className="ev-input"
                                    value={form.comment}
                                    onChange={(eventTarget) =>
                                        setForm((current) => ({ ...current, comment: eventTarget.target.value }))
                                    }
                                    placeholder="Commentaire optionnel"
                                    style={{ minHeight: 90 }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="ev-modal-footer">
                        <button type="button" className="ev-btn ev-btn-light" onClick={onClose}>
                            Annuler
                        </button>
                        <button type="submit" className="ev-btn ev-btn-primary" disabled={loading}>
                            {loading ? loadingLabel : submitLabel}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
